import { apiClient } from '@/api/client';
import type { LogEntry, LogQuery } from '@/features/logs/types';

/** Mail log search — existing mail-admin-service /logs endpoint (tenant-scoped server-side). */
export const logsApi = {
  search: async (q: LogQuery): Promise<LogEntry[]> => {
    const { data } = await apiClient.get<LogEntry[] | { data: LogEntry[] }>('/logs', { params: q });
    return Array.isArray(data) ? data : data.data;
  },
};
